import { render, staticRenderFns } from "./LoginWrapper.vue?vue&type=template&id=044710d8&scoped=true&"
import script from "./LoginWrapper.vue?vue&type=script&lang=js&"
export * from "./LoginWrapper.vue?vue&type=script&lang=js&"
import style0 from "./LoginWrapper.vue?vue&type=style&index=0&id=044710d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044710d8",
  null
  
)

export default component.exports